import "@fontsource/mada"
import "@fontsource/russo-one"
import "./src/styles/global.css"
import { config } from '@fortawesome/fontawesome-svg-core'

config.autoAddCss = false